import { Injectable } from '@angular/core';
import { BaseApiService } from '@max/shared/base-service/base-api.service';
import { Observable } from 'rxjs';
import { AircraftInformationModel } from '../models/aircraft-information.model';
import { AircraftLedgerInfo } from '../models/aircraft-ledger-info.model';
import { AircraftModel } from '../models/aircraft.model';
import { RegistrationCycle } from '../models/registration-cycle.model';

@Injectable()
export class AircraftService extends BaseApiService {

    constructor() {
        super();
    }

    public getAircraftInformation = (aircraftId: number): Observable<AircraftInformationModel> => this.get(`Aircraft/Aircraft/Information/${aircraftId}`);

    public saveAircraft = (aircraft: AircraftModel): Observable<any> => this.post('Aircraft/Aircraft/Create', aircraft);

    public getLedgerTransactions = (recordId: number): Observable<{ result: RegistrationCycle[] }> => this.get(`Aircraft/Aircraft/Record/${recordId}/Ledger`);

    public getLedgerAircraftInfo = (aircraftId: string): Observable<{result: AircraftLedgerInfo}> => this.get(`Aircraft/Aircraft/Information/${aircraftId}/Ledger`);

    public generateLedger = (recordId: string): Observable<{ result: boolean }> => this.get(`Aircraft/Aircraft/Record/${recordId}/Ledger/Print`);

    public generateInvoice = (recordId: string): Observable<{ result: boolean }> => this.get(`Aircraft/Aircraft/Record/${recordId}/Invoice`);

    public distributePayment = (recordId: string, paymentAmount: string, adjustments: any): Observable<any> => this.post(`Aircraft/Aircraft/Record/${recordId}/Payment/${paymentAmount}`, adjustments);
}
